@if (isTopBarVisible) {
  <ppl-top-bar>
    <ppl-top-navigation></ppl-top-navigation>
  </ppl-top-bar>
}

<ppl-app-container>
  @if (showLoader$ | async) {
    <ppl-loading-overlay
      [visible]="false"
      [inverse]="false"
      [large]="true"></ppl-loading-overlay>
  }
  <div class="select-space-container">
    <div class="select-space-inner-container">
      <ppl-icon
        svgIcon="logo-coevera-white"
        width="243px"
        height="55px"></ppl-icon>
      <br />
      <div class="background-box">
        <h1
          class="select-space-text"
          i18n="@@Select_your_working_space">
          Select your working space
        </h1>
        <div class="space-items">
          @if ((spaces$ | async).length > 0) {
            @for (space of spaces$ | async; track space) {
              <a
                href="{{ space.appBaseUrl }}/space/{{ space.id }}"
                class="space-item"
                (click)="onSpaceSelect(space)">
                <div class="space-item_inner">
                  <div class="picture-container">
                    <div
                      class="picture"
                      [class.picture--no-picture]="!space.pictureUrl">
                      @if (space.pictureUrl) {
                        <img
                          src="{{ space.pictureUrl }}"
                          alt="{{ space.name }}"
                          title="{{ space.name }}" />
                      } @else {
                        <div class="picture-phantom">
                          <ppl-icon
                            svgIcon="pipeline-phantom"
                            width="30px"
                            height="30px"></ppl-icon>
                        </div>
                      }
                      @if (!canAccessSpace(space)) {
                        <div
                          class="space-item_badge space-item_badge--error"
                          title="Expired"
                          i18n-title="@@Expired"
                          i18n="@@Expired">
                          Expired
                        </div>
                      } @else {
                        @if (isLoginRequired(space) || isSessionReloginRequired(space)) {
                          <div
                            class="space-item_badge space-item_badge--warning"
                            title="Login Required"
                            i18n-title="@@Login_Required"
                            i18n="@@Login_Required">
                            Login Required
                          </div>
                        } @else if (isTwoStepVerificationNeeded(space)) {
                          <div
                            class="space-item_badge space-item_badge--warning"
                            title="2-Step Required"
                            i18n-title="@@2-Step_Required"
                            i18n="@@2-Step_Required">
                            2-Step Required
                          </div>
                        } @else if (isAccessFromRestrictedIP(space)) {
                          <div
                            class="space-item_badge space-item_badge--error"
                            title="Access Restricted"
                            i18n-title="@@Access_Restricted"
                            i18n="@@Access_Restricted">
                            Access Restricted
                          </div>
                        }
                      }
                    </div>
                  </div>
                  <div class="title">
                    {{ space.name }}
                  </div>
                  <div class="tier">
                    {{ 'EnumSubscriptionProductTier_' + space.subscription.productTier | t }}
                  </div>
                </div>
              </a>
            }
          } @else {
            <div
              class="no-space-text"
              i18n="@@No_access!_You_are_not_member_of_any_team_space!">
              No access! You are not member of any team space!
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</ppl-app-container>
